import InstructionsPWA from './InstructionsPWA';
export default InstructionsPWA;